import React, { Component } from "react";
import {Container, Row, Col,Image,Accordion,Button,OverlayTrigger,Tooltip,Form  } from 'react-bootstrap';
import { withRouter,Link } from "react-router-dom";
import loader from '../../images/loader.gif';
import "../EventsAndActivities/EventsAndActivities.css";
import axios from 'axios';
import arrowLeft from '../../images/arrow-left.png';
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import CardLessDataTableWithSearch from '../datatables/CardLessDataTableWithSearch';
import CardLessDataTableYellowWithOutSearch from '../datatables/CardLessDataTableYellowWithOutSearch';
import HouseWiseVotersD2DModal from "./HouseWiseVotersD2DModal";

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };

class CampaignWiseHouses extends Component {
  constructor(props) {
    super(props);
    this.state = {
     campaignId:props?.location?.params?.campaignId == undefined ? "" : props?.location?.params?.campaignId,
     campaignName:props?.location?.params?.campaignName == undefined ? "" : props?.location?.params?.campaignName,
     userIdSet:props?.location?.params?.userIdSet == undefined ? "" : props?.location?.params?.userIdSet,

     boothParam:props?.location?.params?.boothParam || {},
     constituencyParam:props?.location?.params?.constituencyParam || {},


     tokenSet:"",

     constituencyValue:"",
     constituencyId:"",
     constituencyListArr:[],

     boothValue:"",
     boothListArr:[],
     boothId:"",
     validateboothId:"",
     getBoothsLoadingSymbol:"hide",

     enrollCheckVal:"",

     searchHouseVoters:"",

     houseWiseVotersArr:[],
     houseWiseVoterCheck:0,
     houseWiseVoterLoading:"hide",
     houseWiseVotersModal:false,
     houseWiseVotersId:"",
     houseNoForVoters:"",
     allConsBoothsDataArr:[]
    };
    
    
  }

  componentDidMount() {
    if(this.state.campaignId == ""){
        this.props.history.push({pathname:"/d2dCampagin",params: { navbarDisplay:"hide"}});
    }else{
        this.getTokenForD2DCampaign();
    }
  }


getTokenForD2DCampaign = async() => {
  try {
    const response = await axios.get(
      'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/admin',
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    const token = response.data.token; // or adjust key as per actual response
    this.setState({tokenSet:token})
    console.log('✅ Token:', token);

    this.getConstituencyWithBooths(token);
   
  } catch (error) {
     this.setState({tokenSet:""})
    console.error('❌ Failed to get token:', error.response?.data || error.message);
  }
}

 getConstituencyWithBooths = async (tokenStr) => {
  try {
    const response = await axios.post(
      'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/access',
      {
        userId: this.state.userIdSet  // ✅ Request body
      },
      {
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          'Content-Type': 'application/json' // (optional but recommended)
        }
      }
    );

    if(response.data !=null){
        if(response.data?.data !=null && response.data?.data.length>0){
            this.setState({allConsBoothsDataArr:response.data?.data})
                this.setState({ boothListArr: [],getBoothsLoadingSymbol:"show",validateboothId:""});
                var consArr=[];
                for(var i in  response.data?.data){
                    var obj={'value':response.data?.data[i].id,'label':response.data?.data[i].assemblyName};
                    consArr.push(obj);
                }
            
                this.setState({ constituencyListArr:consArr });

                setTimeout(() => {
                    if(consArr.length>0){
                        if(Object.keys(this.state.constituencyParam).length == 0){
                            this.setState({
                                    constituencyValue: {
                                    value: response.data?.data[0].id,
                                    label: response.data?.data[0].assemblyName
                                },constituencyId:response.data?.data[0].id
                            });
                        }else{
                            for(var i in consArr){
                                if(this.state.constituencyParam.value == consArr[i].value){
                                    this.setState({
                                    constituencyValue: {
                                            value: consArr[i].value,
                                            label: consArr[i].label
                                        },constituencyId:consArr[i].value
                                    });
                                }
                            }
                        
                            console.log("constituencyParam",this.state.constituencyParam)
                        }
                    }
                }, 800);   

                
               

            for(var i in  response.data?.data){
                if(response.data?.data[i].data !=null && response.data?.data[i].data.length>0){
                    this.setState({ getBoothsLoadingSymbol:"hide",validateboothId:""});
                    var boothArr=[];
                    for(var j in  response.data?.data[i].data){
                        var obj={'value':response.data?.data[i].data[j].boothId,'label':"Booth-"+response.data?.data[i].data[j].boothName};
                        boothArr.push(obj)
                        
                    }
                    this.setState({ boothListArr:boothArr });

                    setTimeout(() => {
                    if(boothArr.length>0){
                        if(Object.keys(this.state.boothParam).length > 0){
                            for(var i in boothArr){
                                if(this.state.boothParam.value == boothArr[i].value){
                                    this.setState({
                                    boothValue: {
                                            value: boothArr[i].value,
                                            label: boothArr[i].label
                                        },boothId:boothArr[i].value
                                    });
                                }
                            }

                            this.getHouseWiseVotersCheckToken(this.state.boothParam.value);
                        }else{
                            this.setState({
                                boothValue: {
                                        value: boothArr[0].value,
                                        label: boothArr[0].label
                                    },boothId:boothArr[0].value
                                });
                            this.getHouseWiseVotersCheckToken(boothArr[0].value);
                        }
                    }
                }, 500); 

                }else{
                    this.setState({getBoothsLoadingSymbol:"hide",validateboothId:"No Booths"})
                }
            }

        }else{
            this.setState({constituencyId:"",constituencyValue:"",constituencyListArr:[],boothListArr:[],getBoothsLoadingSymbol:"hide",validateboothId:"No Booths"})
        }
    }else{
        this.setState({constituencyId:"",constituencyValue:"",constituencyListArr:[],boothListArr:[],getBoothsLoadingSymbol:"hide",validateboothId:"No Booths"})
    }

    console.log("constituencyBooths:", response.data);
  } catch (error) {
    this.setState({constituencyId:"",constituencyValue:"",constituencyListArr:[],boothListArr:[],getBoothsLoadingSymbol:"hide",validateboothId:"No Booths"})
    console.error("Error fetching constituency booths:", error.response?.data || error.message);
  }
};


handleOnchangeSelectBoxForD2D = (ename, evalue) =>{
        const name = ename;
        const value = evalue;
    
        if(name == "constituencyId"){
            let getConsIdName = this.state.constituencyListArr.find((a) => a.value == value);
                this.setState({
                    constituencyValue: {
                    value: getConsIdName.value,
                    label: getConsIdName.label
                }
            });

            this.constituencyWiseBoothsCall(getConsIdName.value);

        }else if(name == "boothId"){
            let getBoothIdName = this.state.boothListArr.find((a) => a.value == value);
            this.setState({
                boothValue: {
                value: getBoothIdName.value,
                label: getBoothIdName.label
            }
        });

        this.setState({enrollCheckVal:"",houseWiseVotersArr:[],houseWiseVoterCheck:0,houseWiseVoterLoading:"hide"})
           
        }
          
    
        this.setState({ [name]: value});
}

constituencyWiseBoothsCall = (id) => {
 this.setState({ boothListArr:[],boothValue:"",boothId:"" });
 
    console.log("deeeeeeeeeeee",this.state.allConsBoothsDataArr);

    for(var i in this.state.allConsBoothsDataArr){
        if(this.state.allConsBoothsDataArr[i].id == id){
            var boothArr=[];
            for(var j in  this.state.allConsBoothsDataArr[i].data){
                var obj={'value':this.state.allConsBoothsDataArr[i].data[j].boothId,'label':"Booth-"+this.state.allConsBoothsDataArr[i].data[j].boothName};
                boothArr.push(obj)
                
            }
            this.setState({ boothListArr:boothArr });
        }
    }

}


getHouseWiseVoters = (boothId) => {
     this.getHouseWiseVotersCheckToken(boothId);
}


  getHouseWiseVotersCheckToken = async(boothId) => {
    try {
      const response = await axios.get(
        'https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/admin',
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
  
      const token = response.data.token; // or adjust key as per actual response
      console.log('✅ Token:', token);
  
     this.getHouseWiseVotersData(token,boothId);
     
    } catch (error) {
      console.error('❌ Failed to get token:', error.response?.data || error.message);
    }
  }

getHouseWiseVotersData = async (token,boothId) => {
    this.setState({houseWiseVotersArr:[],houseWiseVoterCheck:0,houseWiseVoterLoading:"show"});

   let inputObj = {
        boothId: boothId,
        campaignId: this.state.campaignId,
        userId: this.state.userIdSet,
    };

    // Only add "verified" if enrollCheckVal is not null or undefined
    if (this.state.enrollCheckVal !== undefined && this.state.enrollCheckVal !== null && this.state.enrollCheckVal !== "") {
        inputObj.verified = this.state.enrollCheckVal;
    }


    try {
        const response = await axios.post('https://api.mytdpapp.com/megatron/mytdp/iam/api/v1/users/addresses?offset=0&limit=1000', 
        inputObj,
        {
        headers: {
            Authorization: `Bearer ${token}`
        }
        });

        this.setState({houseWiseVoterLoading:"hide"}); 
        if(response.data !=null){ 
            if(response.data?.data !=null && response.data?.data.length>0){
                 console.log("dddddddddddaa",response.data?.data)
                 this.setState({houseWiseVotersArr:response.data?.data,houseWiseVoterCheck:0});
            }else{
                this.setState({houseWiseVotersArr:[],houseWiseVoterCheck:1});
            }
           
        }else{
             this.setState({houseWiseVotersArr:[],houseWiseVoterCheck:1});
        }

        console.log("Data:", response.data);
    } catch (error) {
         this.setState({houseWiseVotersArr:[],houseWiseVoterCheck:1});
        console.error("Error fetching campaigns:", error.response?.data || error.message);
    }
}



checkEnrolled = (e,type) => {
    this.setState({enrollCheckVal:type});
}

houseListDisplayColumsD2DCampaign() {
    let columns = [
        
        {
            dataField: "houseNumber",
            text: "House No",
            sort: true,
            formatter: this.actionsFormatterHouseWiseVoterDetails.bind(this),
            headerStyle: {
                width: "15%"
            }
            
            
        },
        {
            dataField: "elderName",
            text: "Elder Person",
           // sort: true,
            formatter: this.actionsFormatterElderPerson.bind(this),
            headerStyle: {
                width: "40%"
            }
            
            
        },
        {
            dataField: "youngerName",
            text: "Younger Person",
            formatter: this.actionsFormatterYoungerPerson.bind(this),
            headerStyle: {
                width: "40%"
            }
        },{
            dataField: "Action",
            text: "A/c",
            headerStyle: {
                width: "20%"
            },
            formatter: this.actionsFormatterForActionVisit.bind(this),
        }
    
    ];
    return columns;
}
getFormattedName(name) {
  if (!name || typeof name !== 'string') return '';
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

actionsFormatterHouseWiseVoterDetails = (cell, row, rowIndex, formatExtraData) => {
    return (
         <OverlayTrigger key={"top"} placement={"top"}
            overlay={
                <Tooltip id={`tooltio-Filter`}>
                <h6 className='f-12'>Click Here To Get Voters</h6>
                </Tooltip>
            }
        >
            <span style={{textAlign:"left",marginLeft:"0px",cursor:"pointer",textDecoration:"underline"}} onClick={() => this.getHouseWiseVotersModals(row.houseNumberId,row.houseNumber)}>{((row.houseNumber))} </span>
        </OverlayTrigger>

        
        
     );
}
actionsFormatterForActionVisit = (cell, row, rowIndex, formatExtraData) => {

    return(
        <>
       {
        row.houseNumberVerified == true ?
        (
             <button className="btn btn-sm btn-success"  style={{fontSize:"11px",padding:"2px 6px",cursor:"auto"}}>Visited</button>
        )
        :
        (
             <button className="btn btn-sm btn-warning" onClick={()=> this.getHouseWiseVerification(row)} style={{fontSize:"11px",padding:"2px 6px"}}>Visit</button>
        )
       }
       </>
       

    )
}

actionsFormatterElderPerson = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <span style={{textAlign:"left",marginLeft:"0px"}}>{(this.getFormattedName(row.elderName))} 
           <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>Age - {(row.elderAge)}/{row.elderGender}</span></>
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>VCN - {(row.elderVCN)}</span></>
        </span>
     );
    
} 


actionsFormatterYoungerPerson = (cell, row, rowIndex, formatExtraData) => {

  
    return (
        <span style={{textAlign:"left",marginLeft:"0px"}}>{this.getFormattedName(row.youngerName)} 
           <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>Age - {(row.youngerAge)}/{row.youngerGender}</span></>
            <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>VCN - {(row.youngerVCN)}</span></>
        </span>
     );
    
} 


hoseWiseVoterListDisplayDataD2D = (data) =>{
    let houseWiseDataArr = [];
        if(data.length>0){
            
            for (let i = 0; i < data.length; i++) {

                
                const houseNumber = (data[i].address.houseNumber);
                const houseNumberId = (data[i].address.id);
                const houseNumberVerified = (data[i].address.verified);

                const youngerName = (typeof data[i].address.youngestVoter == "undefined" ? "" : data[i].address.youngestVoter.firstName);
                const youngerGender = (typeof data[i].address.youngestVoter == "undefined" ? "" : data[i].address.youngestVoter.gender);
                const youngerAge = (typeof data[i].address.youngestVoter == "undefined" ? "" : data[i].address.youngestVoter.age);
                const youngerVCN = (typeof data[i].address.youngestVoter == "undefined" ? "" : data[i].address.youngestVoter.voterCardNumber);
                const youngerVoterId = (typeof data[i].address.youngestVoter == "undefined" ? "" : data[i].address.youngestVoter.voterId);
                const youngerDocumentId = (typeof data[i].address.youngestVoter == "undefined" ? "" : data[i].address.youngestVoter.documentId);


                const elderName = (typeof data[i].address.oldestVoter == "undefined" ? "" :  data[i].address.oldestVoter.firstName);
                const elderGender = (typeof data[i].address.oldestVoter == "undefined" ? "" :  data[i].address.oldestVoter.gender);
                const elderAge = (typeof data[i].address.oldestVoter == "undefined" ? "" :  data[i].address.oldestVoter.age);
                const elderVCN = (typeof data[i].address.oldestVoter == "undefined" ? "" :  data[i].address.oldestVoter.voterCardNumber);
                const elderVoterId = (typeof data[i].address.oldestVoter == "undefined" ? "" :  data[i].address.oldestVoter.voterId);
                const elderDocumentId = (typeof data[i].address.oldestVoter == "undefined" ? "" :  data[i].address.oldestVoter.documentId);

                
                const obj = {
                    houseNumber:(houseNumber),
                    houseNumberId:houseNumberId,
                    houseNumberVerified: houseNumberVerified,
                    youngerName: youngerName,
                    youngerGender: youngerGender == "MALE" ? "M" : "F",
                    youngerAge:youngerAge,
                    youngerVCN:youngerVCN,
                    youngerVoterId:youngerVoterId,
                    youngerDocumentId:youngerDocumentId,
                    elderName:elderName,
                    elderGender:elderGender == "MALE" ? "M" : "F",
                    elderAge:elderAge,
                    elderVCN:elderVCN,
                    elderVoterId:elderVoterId,
                    elderDocumentId:elderDocumentId
                   
                    
                }
                houseWiseDataArr.push(obj);
            } 

            
            
            return houseWiseDataArr;
        }
}


handlesearchHouseVotersChange = (event) => {
    this.setState({
        searchHouseVoters: event.target.value
    })
}


getHouseWiseVerification = (row) => {
     this.props.history.push({
            pathname:"/house_wise_verification",
            params: {
                navbarDisplay:"hide",
                campaignId: this.state.campaignId,
                campaignName:this.state.campaignName,
                houseNumberId:row.houseNumberId,
                houseNumber:row.houseNumber,
                boothParam:this.state.boothValue,
                constituencyParam:this.state.constituencyValue,
                userIdSet:this.state.userIdSet
                
            }
        });
}

getHouseWiseVotersModals = (houseId,houseNo) => {
    this.setState({houseWiseVotersModal:true,houseWiseVotersId:houseId,houseNoForVoters:houseNo})
}

  render() {
     let houseWiseVotersManualSearchDataArr=[];
            let keyword = this.state.searchHouseVoters.toString()
            if (keyword !== ''){
                console.log("sssssssssssssssss00",this.state.houseWiseVotersArr)
                houseWiseVotersManualSearchDataArr = this.state.houseWiseVotersArr.filter(item => {
                    console.log("dw22222222220",item)
                    if (item.address.houseNumber.toLowerCase().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address.oldestVoter.voterCardNumber.toLowerCase().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address.oldestVoter.firstName.toLowerCase().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address.oldestVoter.gender.toLowerCase().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address.oldestVoter.age.toString().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address?.youngestVoter?.voterCardNumber.toLowerCase().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address.youngestVoter.firstName.toLowerCase().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address.youngestVoter.gender.toLowerCase().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    if (item.address.youngestVoter.age.toString().startsWith(keyword.toLowerCase())) {
                        return item;
                    }
                    
                } );

                console.log("houseWiseVotersManualSearchDataArr",houseWiseVotersManualSearchDataArr)

            }else{
                houseWiseVotersManualSearchDataArr = this.state.houseWiseVotersArr;
                
            }
        
    return (
      <section className="background_yellow_d2d">
        <div className='bg_yellow_event'>
            <div className='flex_event_name_top'>
                    <div>
                         <Link to={{pathname: "/d2dCampagin",params: {navbarDisplay:"hide"}}}> <Image src={arrowLeft} alt="Arrow" ></Image></Link>
                    </div>  
                    <div>
                        <h6 className='color_white fw-bold mt-3'>{this.state.campaignName}</h6>
                    </div> 
            </div>
        </div>

            <Container>
                <Row>
                    <Col className='mt-3'>
                    <label className="form-label f-12 fw-bold">Constituency<span className='color_red f-14 ms-1'>*</span></label>
                    <SelectBox
                            stateData={this.state.constituencyValue}
                            handleChange={this.handleOnchangeSelectBoxForD2D}
                            name="constituencyId"
                            options={this.state.constituencyListArr}
                            placeholderName={'Constituency'}
                            dropdownIndicator={{ DropdownIndicator }}
                        />
                </Col>
                <Col className='mt-3'>
                    <label className="form-label f-12 fw-bold">Booth<span className='color_red f-14 ms-1'>*</span><span className='f-12 color_red'>{this.state.validateboothId}</span>
                        {
                            this.state.getBoothsLoadingSymbol == "show" ?
                            (<Image src={loader} alt="loader" className='loader_cls ms-2 float-end'></Image>)
                            :
                            ("")
                        }
                        
                    </label>
                    <SelectBox
                            stateData={this.state.boothValue}
                            handleChange={this.handleOnchangeSelectBoxForD2D}
                            name="boothId"
                            options={this.state.boothListArr}
                            placeholderName={'Booth'}
                            dropdownIndicator={{ DropdownIndicator }}
                        />
                </Col>
            </Row>
            
            {
                this.state.boothId != "" ?
                (
                    <>
                        <Row>
                            <Col>
                            <Form>
                                <div className='text-center mt-3'>
                                <Form.Check
                                    inline
                                    label={`All`}
                                    name="enrolledName"
                                    type="radio"
                                    id={`allenrolledId`}
                                    onChange={(e)=>this.checkEnrolled(e,"")}
                                    className="f-14 fw-bold color_black"
                                    value=""
                                    defaultChecked={true}
                                />
                                <Form.Check
                                    inline
                                    label={`Visited`}
                                    name="enrolledName"
                                    type="radio"
                                    id={`enrolledId`}
                                    onChange={(e)=>this.checkEnrolled(e,true)}
                                    className="f-14 fw-bold color_black"
                                    value="Y"
                                />
                                <Form.Check
                                    inline
                                    label={`Not Visited`}
                                    name="enrolledName"
                                    type="radio"
                                    id={`notEnrolledId`}
                                    onChange={(e)=>this.checkEnrolled(e,false)}
                                    className="f-14 fw-bold color_black"
                                    value="N"
                                    
                                />
                                    </div>
                            </Form>   
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button variant="dark" className='f-12 center-auto mt-4 mb-3' onClick={() => this.getHouseWiseVoters(this.state.boothId)}>GET HOUSE DETAILS</Button> 
                            </Col>
                        </Row>

                        {
                            this.state.houseWiseVoterLoading == "show" ?
                            (
                                <Row>
                                    <Col sm={12}>
                                        <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                    </Col>
                                </Row>
                            )
                            :
                            ("")
                        }

                        {
                            this.state.houseWiseVotersArr.length>0 ?
                            (
                                <>

                                    <Row>
                                        <Col sm={12}>
                                        <h6 className="f-14 fw-bold mt-4">{this.state.boothValue.label} House Details : </h6>
                                        
                                        <div className='bg_light_white mt-3'>
                                            <Row>
                                                <Col sm={6}>
                                                    <input
                                                        className='float-end search_bar mt-2'
                                                        type="search"
                                                        placeholder='Search'
                                                        value={this.state.searchHouseVoters}
                                                        onChange={this.handlesearchHouseVotersChange}
                                                    />
                                                    <i className='fa fa-search search-icon'></i>
                                                </Col>
                                            </Row>

                                            {
                                                houseWiseVotersManualSearchDataArr.length>0 ? 
                                                (
                                                    <CardLessDataTableYellowWithOutSearch 
                                                        parentData={this.hoseWiseVoterListDisplayDataD2D(houseWiseVotersManualSearchDataArr)}
                                                        particlecolumns={this.houseListDisplayColumsD2DCampaign()}
                                                        defaultSorted={[{
                                                            dataField: "houseNumber",
                                                            order: "asc"
                                                        }]}
                                                        tableHeading=""
                                                        />
                                                )
                                                :
                                                ("")
                                            }

                                             </div>
                                    
                                    </Col>
                                </Row>

                                </>
                            )
                            :
                            (<>
                                {
                                this.state.houseWiseVoterCheck == 1 ?
                                (<h6 className='f-14 text-center mt-4'>No Houses Availabel In this Booth...</h6>)
                                :
                                ("")
                            }
                            </>)
                        }
                    </>
                )
                :
                ("")
            }

            <HouseWiseVotersD2DModal 
                show={this.state.houseWiseVotersModal}
                onHide={() => this.setState({ houseWiseVotersModal: false })}
                stateData={this.state}
            />

        </Container>
    </section>

    );
  }
}

export default withRouter(CampaignWiseHouses);
